// TODO: make this a real cache module with asset preloading etc.
export default {}
